import { LoadableAfterPaint } from '@confluence/loadable';

export const ArchivedPageBanner = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchivedPageBanner" */ '../src/ArchivedPageBannerV2.tsx'
			)
		).ArchivedPageBanner,
});
